<template>
  <div id="app">
    <!-- 顶部导航栏 -->
    <el-header style="background-color: #409EFF; color: white; padding: 0;">
      <div class="logo">{{ orgInfor ? orgInfor.orgName : '**机构' }}</div>
    </el-header>
    <el-container style="padding: 20px;">
      <!-- 轮播图区域 -->
      <el-carousel :interval="5000" arrow="always" style="height: 400px;">
        <el-carousel-item v-for="(image, index) in images" :key="index">
          <img :src="image.src" :alt="image.alt" />
        </el-carousel-item>
      </el-carousel>
    </el-container>

    <!-- 咨询问题展示 -->
    <el-container style="padding: 20px;">
      <el-main>
        <h2>咨询问题展示</h2>
        <el-row :gutter="20">
          <el-col v-for="(item, index) in consultations" :key="index" :span="8">
            <el-card shadow="hover">
              <h3>问题 {{ index + 1 }}：</h3>
              <p>{{ item.question }}</p>
              <el-divider></el-divider>
              <h4>答复：</h4>
              <p>{{ item.answer }}</p>
            </el-card>
          </el-col>
        </el-row>
        <!-- 提问按钮 -->
        <el-button type="primary" @click="openQuestionForm" style="margin-top: 20px;">
          我也要提问
        </el-button>
      </el-main>
    </el-container>

    <!-- 机构介绍 -->
    <el-container style="padding: 20px;">
      <el-main>
        <h2>关于我们</h2>
        <p>
          {{ orgInfor ? orgInfor.description : '我们是一家致力于提供优质服务的机构，专注于教育培训与企业合作。我们的目标是为学员提供全面的学习资源，帮助他们在各自的领域中获得成功。' }}
        </p>
      </el-main>
    </el-container>

    <!-- 视频展示部分 -->
    <el-container style="padding: 20px;">
      <el-main>
        <h2>公开视频</h2>
        <el-row gutter="20">
          <!-- 循环输出视频 -->
          <el-col v-for="(video, index) in videos" :key="index" :span="8">
            <el-card shadow="hover">
              <video controls style="width: 100%; height: 200px;">
                <source :src="video.videoPath" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div class="video-title">{{ video.title }}</div>
            </el-card>
          </el-col>
        </el-row>
      </el-main>
    </el-container>

    <!-- 提问表单弹窗 -->
    <el-dialog
        title="提问表单"
        v-model="dialogVisible"
        width="50%"
        @close="resetForm"
    >
      <el-form :model="questionForm" ref="questionForm">
        <el-form-item label="问题" prop="question" :rules="[{ required: true, message: '请输入您的问题', trigger: 'blur' }]">
          <el-input v-model="questionForm.question" type="textarea" placeholder="请输入您的问题" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitQuestion">提交</el-button>
      </span>
    </el-dialog>

    <!-- 页脚 -->
    <el-footer style="background-color: #409EFF; color: white; text-align: center; padding: 10px;">
      <p>&copy; 2024 {{ orgInfor ? orgInfor.name : '**机构' }} | 版权所有</p>
    </el-footer>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  props: {
    userid: {
      type: Number,
      required: true,
    },
    organizationID: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // 视频信息数组
      videos: [],
      images: [],
      consultations: [],
      dialogVisible: false, // 控制弹窗显示
      questionForm: {
        question: "",
      },
      orgInfor: null, // 机构信息
    };
  },
  created() {
    const param = {
      organizationId: this.organizationID,
      page: 0,
      size: 100,
    };
    // 获取视频列表
    axios
        .get("/videos/search1", {params: param})
        .then((response) => {
          this.videos = response.data.data;
        })
        .catch((error) => {
          this.$message.error("获取视频列表失败");
        });
    // 获取图片列表
    axios
        .get("/images/search1", {params: param})
        .then((response) => {
          this.images = response.data.data;
        })
        .catch((error) => {
          this.$message.error("获取图片列表失败");
        });
    // 获取咨询问题列表
    axios
        .get("faq/search1", {params: param})
        .then((response) => {
          this.consultations = response.data.data;
        })
        .catch((error) => {
          this.$message.error("获取咨询问题失败");
        });
    // 获取机构信息
    axios
        .get("faq/orgInfor", {params: {organizationId: this.organizationID}})
        .then((response) => {
          this.orgInfor = response.data.data;
        })
        .catch((error) => {
          this.$message.error("获取机构信息失败");
        });
  },
  methods: {
    // 打开提问表单
    openQuestionForm() {
      this.dialogVisible = true;
    },
    // 重置表单
    resetForm() {
      this.$refs.questionForm.resetFields();
    },
    // 提交提问表单
    submitQuestion() {
      this.$refs.questionForm.validate((valid) => {
        if (valid) {
          // 提交表单
          axios
              .post("/faq/submit", {
                question: this.questionForm.question,
                userid: this.userid,
                organizationID: this.organizationID,
              })
              .then((response) => {
                if (response.data.success) {
                  this.$message.success("提问成功！");
                  this.dialogVisible = false; // 关闭弹窗
                  this.resetForm(); // 重置表单
                } else {
                  this.$message.error(response.data.errorMsg);
                }
              })
              .catch((error) => {
                this.$message.error("提问失败，请重试");
              });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
#app {
  font-family: Arial, sans-serif;
  min-height: 100vh; /* 页面最小高度为视口高度 */
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏样式 */
.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

/* 轮播图 */
.el-carousel {
  width: 100%;
}

.el-carousel img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 视频展示样式 */
.el-card {
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
}

.el-row {
  margin-top: 20px;
}

/* 视频标题 */
.video-title {
  margin-top: 10px;
  font-size: 16px;
  text-align: center;
  color: #333;
}

/* 咨询问题样式 */
h3 {
  color: #409eff;
}

h4 {
  color: #67c23a;
}

/* 提问按钮 */
.el-button {
  margin-top: 20px;
}

/* 页脚样式 */
.el-footer {
  font-size: 14px;
  margin-top: auto; /* 页脚自底部显示 */
}
</style>